import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TreeListItem } from '../../interfaces/tree-list-item.model';
import { StudiesService } from '../../services/studies.service';

@Component({
  selector: 'app-calculation-chamber-investigations',
  templateUrl: './calculation-chamber-investigations.component.html',
  styleUrls: ['./calculation-chamber-investigations.component.scss'],
})
export class CalculationChamberInvestigationsComponent implements OnInit {
  list: TreeListItem[] = [];
  multipleStatus = false;
  selectedTab: number = 1;

  itemsToDisplay: TreeListItem[] = [];

  constructor(private studiesService: StudiesService) {}

  ngOnInit() {
    this.studiesService.all().subscribe(a => {
      this.list = a.map(b => {
        return <TreeListItem>{
          text: b.title,
          link: `/rekenkamer/${b.id}`,
          status: b.status,
        };
      });

      this.itemsToDisplay = this.list;
    });
  }

  switchView(tab) {
    this.selectedTab = tab;
    switch (this.selectedTab) {
      case 1:
        this.itemsToDisplay = this.list;
        break;
      case 2:
        this.itemsToDisplay = this.list.filter(a => a.status === 0);
        break;
      case 3:
        this.itemsToDisplay = this.list.filter(a => a.status === 1);
        break;
      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/calculation-chamber-investigations/calculation-chamber-investigations.component.ts